(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["l4s-search-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-l4s-predictive')) return;
    if (!event.inputType || !window.matchMedia('(pointer: fine)').matches) return;

    const modal = document.getElementById('search-modal');
    const modalInput = modal && modal.querySelector('input[name="q"]');
    if (!modalInput || typeof modal.showDialog !== 'function') return;

    modal.showDialog();
    requestAnimationFrame(() => {
      modalInput.value = input.value;
      input.value = '';
      modalInput.focus();
      modalInput.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText' }));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
